import IntelligentElectricAdjustmentSystem from "./intelligentElectricAdjustmentSystem/index.vue";
import IntelligentPetFeeder from "./intelligentPetFeeder/index.vue";
import LovableHome from "./lovableHome/index.vue";
import ChannelAdvertisingFundManagementPlatform from "./channelAdvertisingFundManagementPlatform/index.vue";
import GeneticMetabolicBrainWhiteMatterJudgmentSystem from "./geneticMetabolicBrainWhiteMatterJudgmentSystem/index.vue";

export const richHtmlCaseMap = {
  intelligentElectricAdjustmentSystem: {
    title: "RC模型智能电调控制平台",
    bgColor: "#0a0e17",
    poster: require("@/assets/images/richHtml/intelligentElectricAdjustmentSystem/poster1.png"),
    component: IntelligentElectricAdjustmentSystem,
  },
  intelligentPetFeeder: {
    title: "DownyPaws 智能宠物喂食器",
    bgColor: "#f8fafc",
    poster: require("@/assets/images/richHtml/intelligentPetFeeder/poster1.png"),
    component: IntelligentPetFeeder,
  },
  lovableHome: {
    title: "宠爱有家",
    bgColor: "#ffffff",
    poster: require("@/assets/images/richHtml/lovableHome/poster1.png"),
    component: LovableHome,
  },
  channelAdvertisingFundManagementPlatform: {
    title: "渠道广告资金管理平台",
    bgColor: "#ffffff",
    poster: require("@/assets/images/richHtml/channelAdvertisingFundManagementPlatform/poster1.png"),
    component: ChannelAdvertisingFundManagementPlatform,
  },
  geneticMetabolicBrainWhiteMatterJudgmentSystem: {
    title: "遗传代谢性脑白质判断系统",
    bgColor: "#f2f3f5",
    poster: require("@/assets/images/richHtml/geneticMetabolicBrainWhiteMatterJudgmentSystem/poster-small.png"),
    component: GeneticMetabolicBrainWhiteMatterJudgmentSystem,
  },
};

export const richHtmlCaseNames = Object.keys(richHtmlCaseMap);
